
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus/search",
      function () {
        return require("private-next-pages/plus/search/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus/search"])
      });
    }
  